import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { RoamingCountriesPartnersComponent } from '../../roaming-countries-partners/roaming-countries-partners.component';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
import { ProductService } from '../../services/product.service';
import { UtilitiesService } from '../../utilities/utilities.service';

@Component({
  selector: 'app-alaphabetic-country-list',
  templateUrl: './alaphabetic-country-list.component.html',
  styleUrls: ['./alaphabetic-country-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AlaphabeticCountryListComponent implements OnInit  {
  @Input('data') data: any;
  countries: any;
  backupCountries: any;
  lang: string;
  searchingCountry: any="";
  showCountryPage: boolean = true;
  selectedCountry:any='';
  sku:any;
  parentCategory:any='';

  isPrefferedPartner=[];
  nonPrefferedParner=[];
constructor(private modalController: ModalController, private PS: ProductService, 
  private UTS: UtilitiesService, private GAS: GoogleAnalyticsService) {  

}

  ngOnInit() {
    this.countries = this.data?.country;
    this.backupCountries = JSON.parse(JSON.stringify(this.data?.country));
    this.lang = this.data?.lang;
  }

  async filterList(evt) {
    this.countries =  JSON.parse(JSON.stringify(this.backupCountries));
    const searchTerm = evt.srcElement.value;
  
    if (!searchTerm) {
      return;
    }
    if(this.lang == 'ar'){
      this.countries = this.countries.filter((data:any) => {
        data.countries = data.countries.filter((ele:any)=>{
        if (ele.nameAr && searchTerm) {
          return (ele.nameAr.indexOf(searchTerm.toLowerCase()) > -1)
        }
      });
      return data;
      });
    }else{
      this.countries = this.countries.filter((data:any) => {
        data.countries = data.countries.filter((ele:any)=>{
        if (ele.countryName && searchTerm) {
          return (ele.countryName.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1)
        }
      });
      return (data.countries.length > 0  ? true : false);
    });
    }
    
  }
  onCountrySelectGA(countryName)
  {
    let modal_data={
      event:'b2b_fire_event',
      eventCategory:'roaming',
      eventAction:'Eligible Countries and Preferred Partners',
      eventLabel:countryName,
      user_env:this.UTS.getENV()
    }
    this.GAS.countrySearch_Roaming(modal_data);
  }
  selectCountry(country){
  this.onCountrySelectGA(country.countryName);
    this.openPartners(country.id);
  }
  openPartners(id)
{
  this.openBottomSheets1(RoamingCountriesPartnersComponent, {id:id, lang : this.lang},'verification-modal eand-radius-modal eand-partail-height-screen-bottom-90 eand-partail-height-screen-bottom-mobile');
}
  async openBottomSheets1(component: any, data?: any,classes='verification-modal modal-fullscreen eand-radius-modal') {
    const modal = await this.modalController.create({
      component: component,
      showBackdrop: true,
      componentProps: { data: data },
      // mode: "ios",
      cssClass: classes,
    });
  
    return await modal.present();
    }
  dismiss() {
    this.modalController.dismiss( this.selectedCountry);
  }

  clear(){
    this.searchingCountry = '';
    this.countries = this.backupCountries;
  }

  back(){
    this.searchingCountry = '';
    this.countries = this.backupCountries;
    this.showCountryPage = true;
  }

  getPartnersStatus(isPreferred:boolean) : boolean {
    return this.selectedCountry&& this.selectedCountry.roamingPartners.some((item:any) => item?.isPreferred == isPreferred);
  }
  
  replaceNumber(data:any){
    const value :any =  data & data.replace(/^0+/, '') || ''; 
    return  value;
  }
}